import * as i0 from '@angular/core';
import { inject, Injectable, Component, NgModule } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
const _forTrack0 = ($index, $item) => $item.organisation;
function LoginComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 2);
  }
}
function LoginComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 3);
  }
}
function LoginComponent_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtext(2, " Die Benutzeranmeldung kann zurzeit nicht durchgef\xFChrt werden, da der Server nicht erreichbar ist.");
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4, " Bitte rufen Sie den IT-Service unter der 44555 an. ");
    i0.ɵɵelementEnd()();
  }
}
function LoginComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LoginComponent_Conditional_6_Conditional_0_Template, 5, 0, "div", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r0.webAuthService.loginInProcess ? 0 : -1);
  }
}
function LoginComponent_Conditional_7_Conditional_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Anmeldung l\xE4uft ... ");
  }
}
function LoginComponent_Conditional_7_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Benutzerdaten werden geladen ... ");
  }
}
function LoginComponent_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 7)(2, "div", 9)(3, "div", 10);
    i0.ɵɵelement(4, "div")(5, "div")(6, "div")(7, "div")(8, "div");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵtemplate(10, LoginComponent_Conditional_7_Conditional_0_Conditional_10_Template, 1, 0)(11, LoginComponent_Conditional_7_Conditional_0_Conditional_11_Template, 1, 0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵconditional(ctx_r0.webAuthService.loginInProcess ? 10 : 11);
  }
}
function LoginComponent_Conditional_7_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.webAuthService.adfsLogInError);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.webAuthService.adfsLogInErrorDescription);
  }
}
function LoginComponent_Conditional_7_Conditional_1_Conditional_2_For_4_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, "Die Anmeldung bei dieser Organisation steht aktuell nicht zur Verf\xFCgung.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const instanceId_r4 = i0.ɵɵreadContextLet(1);
    i0.ɵɵattribute("aria-labelledby", "organisation-" + instanceId_r4);
  }
}
function LoginComponent_Conditional_7_Conditional_1_Conditional_2_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵdeclareLet(1)(2);
    i0.ɵɵelementStart(3, "button", 15);
    i0.ɵɵlistener("click", function LoginComponent_Conditional_7_Conditional_1_Conditional_2_For_4_Template_button_click_3_listener() {
      const adfsInstance_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0.webAuthService.initLoginWithAdfs(adfsInstance_r3));
    });
    i0.ɵɵelement(4, "img", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LoginComponent_Conditional_7_Conditional_1_Conditional_2_For_4_Conditional_5_Template, 2, 1, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const adfsInstance_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    const instanceId_r5 = i0.ɵɵstoreLet((tmp_13_0 = adfsInstance_r3.organisation == null ? null : adfsInstance_r3.organisation.toLowerCase()) !== null && tmp_13_0 !== undefined ? tmp_13_0 : "ard");
    const organisationName_r6 = ctx_r0.getOrganisationName(adfsInstance_r3.organisation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "organisation-" + instanceId_r5)("disabled", !adfsInstance_r3.available);
    i0.ɵɵattribute("aria-label", organisationName_r6);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(instanceId_r5);
    i0.ɵɵproperty("src", ctx_r0.getOrganisationImageUrl(adfsInstance_r3.organisation), i0.ɵɵsanitizeUrl)("alt", organisationName_r6);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!adfsInstance_r3.available ? 5 : -1);
  }
}
function LoginComponent_Conditional_7_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong", 12);
    i0.ɵɵtext(1, " Bitte w\xE4hlen Sie Ihre Organisation zum Anmelden aus. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵrepeaterCreate(3, LoginComponent_Conditional_7_Conditional_1_Conditional_2_For_4_Template, 6, 9, "div", 14, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r0.webAuthService.adfsInstances);
  }
}
function LoginComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, LoginComponent_Conditional_7_Conditional_1_Conditional_1_Template, 5, 2, "div", 6)(2, LoginComponent_Conditional_7_Conditional_1_Conditional_2_Template, 5, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.webAuthService.adfsLogInError ? 1 : ctx_r0.started && ctx_r0.webAuthService.localStorageLoginFailed && (ctx_r0.webAuthService.automaticAdfsLogInTry || ctx_r0.webAuthService.adfsInstances && ctx_r0.webAuthService.adfsInstances.length > 1) ? 2 : -1);
  }
}
function LoginComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LoginComponent_Conditional_7_Conditional_0_Template, 12, 1, "div", 7)(1, LoginComponent_Conditional_7_Conditional_1_Template, 3, 1, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.webAuthService.loginInProcess || ctx_r0.webAuthService.collectUserInfoInProcess ? 0 : 1);
  }
}
class AdfsInstance {}
class WebAuthConfig {}
var Organisation = /*#__PURE__*/function (Organisation) {
  /** Rundfunk Berlin-Brandenburg */Organisation["RBB"] = "RBB";
  /** ARD Hauptstadtstudio */
  Organisation["HSB"] = "HSB";
  /** Informations-Verarbeitungs-Zentrum */
  Organisation["IVZ"] = "IVZ";
  /** Bayerischer Rundfunk */
  Organisation["BR"] = "BR";
  /** Deutschlandradio */
  Organisation["DRADIO"] = "DRADIO";
  /** Deutsche Welle */
  Organisation["DW"] = "DW";
  /** Hessischer Rundfunk */
  Organisation["HR"] = "HR";
  /** Mitteldeutscher Rundfunk */
  Organisation["MDR"] = "MDR";
  /** Norddeutscher Rundfunk */
  Organisation["NDR"] = "NDR";
  /** Saarländischer Rundfunk */
  Organisation["SR"] = "SR";
  /** ARD-Sternpunkt */
  Organisation["STP"] = "STP";
  /** Südwestrundfunk */
  Organisation["SWR"] = "SWR";
  /** radiobremen */
  Organisation["RB"] = "RB";
  /** ARGE Rundfunkbetriebstechnik */
  Organisation["RBT"] = "RBT";
  /** Westdeutscher Rundfunk */
  Organisation["WDR"] = "WDR";
  return Organisation;
}(Organisation || {});
function isArd(organisations) {
  for (const organisation of organisations) {
    if (organisation !== Organisation.RBB && organisation !== Organisation.HSB && organisation !== Organisation.IVZ) {
      return true;
    }
  }
  return false;
}

/* eslint-disable no-console */
// @dynamic
let WebAuthService = /*#__PURE__*/(() => {
  class WebAuthService {
    static {
      this.accessToken = null;
    }
    constructor() {
      this.http = inject(HttpClient);
      this.webAuthConfig = inject(WebAuthConfig);
      this.clientAuthService = inject(ClientAuthService);
      this.authApiDomain = this.webAuthConfig.authApiUrl?.split('/')[2];
      this.serviceUnavailable = false;
      this.accessToken = null;
      this.loginInProcess = true;
      this.collectUserInfoInProcess = 0;
      this.loggedIn = false;
      this.automaticAdfsLogInTry = false;
      this.localStorageLoginFailed = false;
      this.adfsLogInError = '';
      this.adfsLogInErrorDescription = '';
      WebAuthService.reset = () => this.reset();
    }
    reset() {
      console.debug('reset login');
      if (this.loggedIn) {
        this.loginInProcess = true;
        this.authUser = null;
        this.userInfo = null;
        this.apps = [];
        this.serviceUnavailable = false;
        this.accessToken = null;
        this.collectUserInfoInProcess = 0;
        this.automaticAdfsLogInTry = false;
        this.localStorageLoginFailed = false;
        this.adfsLogInError = '';
        this.adfsLogInErrorDescription = '';
        localStorage.removeItem('accessToken');
        this.loggedIn = false;
      }
    }
    startLoginProcess() {
      console.debug('start login');
      this.loadAdfsInstances();
      this.getApps();
      this.loggedIn = false;
      this.loginInProcess = true;
      this.loginWithLocalStorage();
    }
    saveAccessToken(accessToken) {
      localStorage.setItem('accessToken', accessToken);
      this.accessToken = accessToken;
      WebAuthService.accessToken = accessToken;
      this.clientAuthService.loadClientToken();
    }
    loginWithLocalStorage() {
      console.debug('login with local storage');
      const accessToken = localStorage.getItem('accessToken');
      let options = {};
      if (accessToken) {
        options = {
          headers: new HttpHeaders().append('Authorization', 'Bearer ' + accessToken)
        };
      }
      this.loginInProcess = true;
      console.debug('check stored token');
      this.http.get(this.webAuthConfig.authApiUrl + '/check/token', options).subscribe({
        next: value => {
          console.debug('check stored token successful');
          if (value?.username) {
            this.saveAccessToken(accessToken ?? '');
            this.collectUserInformation();
          } else {
            this.localStorageLoginFailed = true;
          }
          this.loginInProcess = false;
          this.checkLoggedIn();
        },
        error: err => {
          console.debug('check stored token failed');
          if (err.status === 0 || err.status >= 500) {
            console.debug('check stored token failed -> service unavailable');
            this.serviceUnavailable = true;
          }
          this.localStorageLoginFailed = true;
          this.loginInProcess = false;
          this.checkLoggedIn();
        }
      });
    }
    initLoginWithAdfs(adfsInstance) {
      if (!adfsInstance.available) {
        return;
      }
      this.initLoginWithAdfsOrganisation(adfsInstance.organisation ?? Organisation.RBB);
    }
    initLoginWithAdfsOrganisation(organisation) {
      this.loginInProcess = true;
      console.debug('init login with adfs for ' + (organisation ?? 'default'));
      this.http.post(this.webAuthConfig.authApiUrl + '/adfs/init', {
        organisation: organisation ?? null,
        redirectUrl: window.location.href
      }).subscribe({
        next: value => {
          if (value?.adfsUrl) {
            window.location.href = value.adfsUrl;
          }
          this.loginInProcess = false;
          this.checkLoggedIn();
        },
        error: err => {
          console.debug('init login with adfs failed');
          console.error(err);
          this.adfsLogInError = err.error.localizedMessage ? err.error.localizedMessage : 'Ein unbekannter Fehler ist aufgetreten.';
          this.adfsLogInErrorDescription = err.error.localizedDescription ? err.error.localizedDescription : '';
          this.loginInProcess = false;
          this.checkLoggedIn();
        }
      });
    }
    finishLoginWithAdfs(accessToken) {
      console.debug('finish login');
      this.automaticAdfsLogInTry = true;
      this.saveAccessToken(accessToken);
      this.loadAdfsInstances();
      this.getApps();
      this.loggedIn = false;
      this.loginInProcess = true;
      this.loginWithLocalStorage();
    }
    collectUserInformation() {
      this.authUser = undefined;
      this.userInfo = undefined;
      if (this.webAuthConfig.ldapInfo) {
        this.collectUserInfoInProcess++;
      }
      if (this.webAuthConfig.userInfoUrl) {
        this.collectUserInfoInProcess++;
      }
      console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
      let options = {};
      if (WebAuthService.accessToken) {
        options = {
          headers: new HttpHeaders().append('Authorization', 'Bearer ' + WebAuthService.accessToken)
        };
      }
      if (this.webAuthConfig.ldapInfo) {
        console.debug('start loading ldap info ' + this.webAuthConfig.authApiUrl + '/check/user');
        if (this.webAuthConfig.ldapExtended) {
          if (options.params) {
            options.params.append('extended', 'true');
          } else {
            options.params = new HttpParams().append('extended', 'true');
          }
        }
        this.http.get(this.webAuthConfig.authApiUrl + '/check/user', options).subscribe({
          next: value => {
            console.debug('ldap info loaded');
            if (value) {
              this.authUser = value;
              document.documentElement.setAttribute('data-organisation', value.organisation);
              this.collectUserInfoInProcess--;
              console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
              this.checkLoggedIn();
            } else {
              this.authUser = null;
              this.collectUserInfoInProcess--;
              console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
              console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
              this.checkLoggedIn();
            }
          },
          error: error => {
            console.debug('loading ldap info failed');
            console.error(error);
            this.authUser = null;
            this.collectUserInfoInProcess--;
            console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
            this.checkLoggedIn();
          }
        });
      }
      if (this.webAuthConfig.userInfoUrl) {
        console.debug('start loading user info ' + this.webAuthConfig.userInfoUrl);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.http.get(this.webAuthConfig.userInfoUrl, options).subscribe({
          next: value => {
            console.debug('user info loaded');
            if (value) {
              this.userInfo = value;
              this.collectUserInfoInProcess--;
              console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
              this.checkLoggedIn();
            } else {
              this.userInfo = null;
              this.collectUserInfoInProcess--;
              console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
              this.checkLoggedIn();
            }
          },
          error: error => {
            console.debug('loading user info failed');
            console.error(error);
            this.userInfo = null;
            this.collectUserInfoInProcess--;
            console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
            this.checkLoggedIn();
          }
        });
      }
    }
    loadAdfsInstances() {
      this.collectUserInfoInProcess++;
      console.debug('start loading adfs instances from ' + this.webAuthConfig.authApiUrl + '/info/adfs-instances');
      console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
      this.http.get(this.webAuthConfig.authApiUrl + '/info/adfs-instances').subscribe({
        next: value => {
          console.debug('adfs instances loaded');
          const instanceOrganisations = value.map(adfsInstance => adfsInstance.organisation).filter(organisation => organisation);
          console.log(instanceOrganisations);
          if (this.webAuthConfig.organisations?.filter(organisation => !instanceOrganisations.includes(organisation)).length) {
            const defaultInstance = value.find(adfsInstance => adfsInstance.organisation === null);
            this.adfsInstances = defaultInstance ? [defaultInstance] : [];
          } else {
            this.adfsInstances = value.filter(adfsInstance => adfsInstance.organisation && this.webAuthConfig.organisations?.includes(adfsInstance.organisation));
          }
          console.log(this.adfsInstances);
          if (!this.adfsInstances?.length) {
            this.serviceUnavailable = true;
          }
          this.collectUserInfoInProcess--;
          console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
          this.checkLoggedIn();
        },
        error: error => {
          console.debug('loading adfs instances failed');
          console.log(error);
          this.serviceUnavailable = true;
          this.adfsInstances = [];
          this.collectUserInfoInProcess--;
          console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
          this.checkLoggedIn();
        }
      });
    }
    getApps() {
      this.collectUserInfoInProcess++;
      console.debug('start loading apps ' + this.webAuthConfig.authApiUrl + '/info/apps');
      console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
      this.http.get(this.webAuthConfig.authApiUrl + '/info/apps').subscribe({
        next: value => {
          console.debug('apps loaded');
          if (value) {
            this.apps = value;
            this.collectUserInfoInProcess--;
            console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
            this.checkLoggedIn();
          } else {
            this.apps = [];
            this.collectUserInfoInProcess--;
            console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
            this.checkLoggedIn();
          }
        },
        error: error => {
          console.debug('loading apps failed');
          console.log(error);
          this.serviceUnavailable = true;
          this.apps = [];
          this.collectUserInfoInProcess--;
          console.debug('current information collect processes: ' + this.collectUserInfoInProcess);
          this.checkLoggedIn();
        }
      });
    }
    checkLoggedIn() {
      console.debug('check current login state');
      this.loggedIn = !!(!this.serviceUnavailable && this.accessToken && this.apps && (!this.webAuthConfig.ldapInfo || this.authUser !== undefined) && (!this.webAuthConfig.userInfoUrl || this.userInfo !== undefined));
      console.debug('login state: ' + this.loggedIn);
      console.debug('-> serviceUnavailable: ' + this.serviceUnavailable);
      console.debug('-> accessToken: ' + this.accessToken);
      console.debug('-> apps: ' + this.apps);
      console.debug('-> webAuthConfig.ldapInfo: ' + this.webAuthConfig.ldapInfo);
      console.debug('-> authUser: ' + this.authUser);
      console.debug('-> webAuthConfig.userInfoUrl: ' + this.webAuthConfig.userInfoUrl);
      console.debug('-> userInfo: ' + this.userInfo);
      if (!this.loggedIn && this.localStorageLoginFailed && this.apps && this.adfsInstances && this.adfsInstances.length === 1 && !this.automaticAdfsLogInTry && this.collectUserInfoInProcess === 0) {
        this.initLoginWithAdfsOrganisation(this.adfsInstances[0].organisation);
        this.automaticAdfsLogInTry = true;
      }
    }
    static {
      this.ɵfac = function WebAuthService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WebAuthService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WebAuthService,
        factory: WebAuthService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WebAuthService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClientAuthService = /*#__PURE__*/(() => {
  class ClientAuthService {
    constructor() {
      this.http = inject(HttpClient);
      this.webAuthConfig = inject(WebAuthConfig);
      this.clientToken = null;
      this.clientHostname = null;
      this.tokenChanged = new Subject();
    }
    static {
      this.clientToken = null;
    }
    static {
      this.clientHostname = null;
    }
    // noinspection JSUnusedGlobalSymbols
    getTokenChanged() {
      return this.tokenChanged.asObservable();
    }
    loadClientToken() {
      const clientToken = localStorage.getItem('clientToken');
      if (this.webAuthConfig.clientServiceUrl && clientToken) {
        this.http.get(this.webAuthConfig.clientServiceUrl + '/api/v1/client-registration/verify', {
          headers: new HttpHeaders().append('X-Client-Token', clientToken),
          responseType: 'text'
        }).subscribe(hostname => {
          if (hostname) {
            this.saveClientToken(clientToken, hostname);
          }
        });
      }
    }
    saveClientToken(clientToken, clientHostname) {
      localStorage.setItem('clientToken', clientToken);
      this.clientToken = clientToken;
      ClientAuthService.clientToken = clientToken;
      this.clientHostname = clientHostname;
      ClientAuthService.clientHostname = clientHostname;
      this.tokenChanged.next();
    }
    clearClientToken() {
      localStorage.removeItem('clientToken');
      this.clientToken = null;
      ClientAuthService.clientToken = null;
      this.tokenChanged.next();
    }
    register() {
      return new Promise((resolve, reject) => {
        if (!WebAuthService.accessToken) {
          reject();
        }
        if (!this.webAuthConfig.clientServiceUrl) {
          reject();
        }
        const clientToken = localStorage.getItem('clientToken');
        if (clientToken) {
          this.http.get(this.webAuthConfig.clientServiceUrl + '/api/v1/client-registration/verify', {
            headers: new HttpHeaders().append('X-Client-Token', clientToken),
            responseType: 'text'
          }).subscribe({
            next: hostname => {
              if (hostname) {
                this.saveClientToken(clientToken, hostname);
                resolve();
              } else {
                this.startRegistration(resolve, reject);
              }
            },
            error: () => {
              this.startRegistration(resolve, reject);
            }
          });
        } else {
          this.startRegistration(resolve, reject);
        }
      });
    }
    startRegistration(resolve, reject) {
      this.http.post(this.webAuthConfig.clientServiceUrl + '/api/v1/client-registration/start', '').subscribe({
        next: data => {
          if (data.token) {
            const clientToken = data.token;
            let checkRegistration = setInterval(() => {
              this.http.get(this.webAuthConfig.clientServiceUrl + '/api/v1/client-registration/verify', {
                headers: new HttpHeaders().append('X-Client-Token', clientToken),
                responseType: 'text'
              }).subscribe({
                next: hostname => {
                  if (hostname) {
                    this.saveClientToken(clientToken, hostname);
                    clearInterval(checkRegistration);
                    checkRegistration = undefined;
                    resolve();
                  }
                }
              });
            }, 1000);
            setTimeout(() => {
              if (checkRegistration) {
                clearInterval(checkRegistration);
                this.clearClientToken();
                reject();
              }
            }, 60000);
            window.location.href = 'rbb://register?service=' + encodeURIComponent(this.webAuthConfig.clientServiceUrl ?? '') + '&user=' + encodeURIComponent(WebAuthService.accessToken ?? '') + '&client=' + encodeURIComponent(clientToken);
          }
        },
        error: () => {
          this.clearClientToken();
          reject();
        }
      });
    }
    static {
      this.ɵfac = function ClientAuthService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClientAuthService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ClientAuthService,
        factory: ClientAuthService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ClientAuthService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginComponent = /*#__PURE__*/(() => {
  class LoginComponent {
    constructor() {
      this.webAuthService = inject(WebAuthService);
      this.started = false;
      this.getOrganisationName = getOrganisationName;
      this.getOrganisationImageUrl = getOrganisationImageUrl;
      const webAuthService = this.webAuthService;
      const webAuthConfig = inject(WebAuthConfig);
      this.ard = isArd(webAuthConfig.organisations ?? []);
      this.title = webAuthConfig.title;
      if (window.location.hash.startsWith('#web-auth:')) {
        const token = window.location.hash.replace('#web-auth:', '');
        const decodedToken = JSON.parse(window.atob(token));
        history.replaceState(null, '', window.location.pathname);
        if (decodedToken?.accessToken) {
          // eslint-disable-next-line no-console
          console.debug('access token in url detected -> finish authentication');
          webAuthService.finishLoginWithAdfs(decodedToken.accessToken);
        } else {
          // eslint-disable-next-line no-console
          console.debug('no access token in url detected -> start authentication');
          this.webAuthService.startLoginProcess();
        }
      } else {
        // eslint-disable-next-line no-console
        console.debug('no access token in url detected -> start authentication');
        this.webAuthService.startLoginProcess();
      }
      this.started = true;
    }
    static {
      this.ɵfac = function LoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginComponent,
        selectors: [["rbb-login"]],
        decls: 8,
        vars: 3,
        consts: [[1, "navbar", "navbar-expand-xl", "bg-light", "fixed-top"], ["href", "#", 1, "navbar-brand"], ["src", "https://tools.rbb-online.de/template/v4/images/ard.svg", "alt", "ARD", 1, "d-inline-block", "align-top", "ard"], ["src", "https://tools.rbb-online.de/template/v4/images/rbb.svg", "alt", "rbb", 1, "d-inline-block", "align-top"], [1, "fade"], [1, "container"], [1, "alert", "alert-danger"], [1, "m-5", "text-center"], [1, "container", "mt-5"], [1, "d-flex", "justify-content-center", "mb-3"], [1, "loader", "active", "lg"], [1, "text-secondary", "pt-3", "small"], [1, "mb-3", "d-block", "text-center", "h3"], [1, "row", "justify-content-center"], [1, "col-lg-3", "col-6", "p-2"], [1, "card", "text-center", "p-5", "pointer", 3, "click", "id", "disabled"], ["role", "presentation", 3, "src", "alt"], ["role", "status", 1, "small", "text-secondary", "text-center", "fw-bold", "px-3"]],
        template: function LoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "nav", 0)(1, "a", 1);
            i0.ɵɵtemplate(2, LoginComponent_Conditional_2_Template, 1, 0, "img", 2)(3, LoginComponent_Conditional_3_Template, 1, 0, "img", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelement(5, "div", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, LoginComponent_Conditional_6_Template, 1, 1)(7, LoginComponent_Conditional_7_Template, 2, 1);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.ard ? 2 : 3);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.webAuthService.serviceUnavailable ? 6 : !ctx.webAuthService.loggedIn ? 7 : -1);
          }
        },
        styles: [".card[_ngcontent-%COMP%]{height:100%;width:100%;justify-content:center}img[_ngcontent-%COMP%]{width:100%}[_ngcontent-%COMP%]:disabled{opacity:.5;cursor:not-allowed!important}[_ngcontent-%COMP%]:disabled   img[_ngcontent-%COMP%]{opacity:60%}[_ngcontent-%COMP%]:disabled + div[_ngcontent-%COMP%]{transform:translateY(calc(-100% - 3px))}"]
      });
    }
  }
  return LoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessTokenInterceptor = /*#__PURE__*/(() => {
  class AccessTokenInterceptor {
    constructor() {
      this.webAuthService = inject(WebAuthService);
      this.webAuthConfig = inject(WebAuthConfig);
    }
    // noinspection JSUnusedGlobalSymbols
    intercept(req, next) {
      // noinspection HttpUrlsUsage
      const checkUrl = req.url.startsWith('https://') || req.url.startsWith('http://') ? req.url : window.location.href;
      if ((checkUrl.startsWith('https://') || checkUrl.startsWith('http://localhost')) && this.webAuthService.accessToken && (this.webAuthService.apps?.find(s => checkUrl.startsWith(s)) || !this.webAuthService.apps && checkUrl.startsWith('https://' + this.webAuthService.authApiDomain) || this.webAuthConfig.userInfoUrl && req.url === this.webAuthConfig.userInfoUrl)) {
        if (!req.headers.has('Authorization')) {
          req = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + this.webAuthService.accessToken)
          });
        }
        return next.handle(req).pipe(catchError(error => {
          if (error.status === 401) {
            this.webAuthService.reset();
          }
          return throwError(() => error);
        }));
      } else {
        // eslint-disable-next-line no-console
        console.debug('Authorization rejected: ' + req.url);
      }
      return next.handle(req);
    }
    static {
      this.ɵfac = function AccessTokenInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessTokenInterceptor)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessTokenInterceptor,
        factory: AccessTokenInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessTokenInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClientTokenInterceptor = /*#__PURE__*/(() => {
  class ClientTokenInterceptor {
    constructor() {
      this.webAuthConfig = inject(WebAuthConfig);
      this.clientAuthService = inject(ClientAuthService);
      this.http = inject(HttpClient);
    }
    // noinspection JSUnusedGlobalSymbols
    intercept(req, next) {
      if (this.clientAuthService.clientToken && (req.headers.has('Web-Auth') || req.headers.has('Authorization') || req.params.has('accessToken')) && !req.headers.has('X-Client-Token')) {
        const clientToken = this.clientAuthService.clientToken;
        req = req.clone({
          headers: req.headers.set('X-Client-Token', clientToken)
        });
        return next.handle(req).pipe(catchError(error => {
          if (error.status === 403) {
            this.http.get(this.webAuthConfig.clientServiceUrl + '/api/v1/client-registration/verify', {
              headers: new HttpHeaders().append('X-Client-Token', clientToken),
              responseType: 'text'
            }).subscribe({
              error: () => {
                this.clientAuthService.clearClientToken();
              }
            });
          }
          return throwError(() => error);
        }));
      }
      return next.handle(req);
    }
    static {
      this.ɵfac = function ClientTokenInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClientTokenInterceptor)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ClientTokenInterceptor,
        factory: ClientTokenInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ClientTokenInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WebAuthModule = /*#__PURE__*/(() => {
  class WebAuthModule {
    static forRoot(config) {
      return {
        ngModule: WebAuthModule,
        providers: [{
          provide: HTTP_INTERCEPTORS,
          useClass: AccessTokenInterceptor,
          multi: true
        }, {
          provide: HTTP_INTERCEPTORS,
          useClass: ClientTokenInterceptor,
          multi: true
        }, {
          provide: WebAuthConfig,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function WebAuthModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WebAuthModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: WebAuthModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideHttpClient(withInterceptorsFromDi())]
      });
    }
  }
  return WebAuthModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class WebAuthUser {}

// noinspection JSUnusedGlobalSymbols
var WebAuthUserType = /*#__PURE__*/function (WebAuthUserType) {
  WebAuthUserType["USER"] = "USER";
  WebAuthUserType["NOT_RBB_USER"] = "NOT_RBB_USER";
  WebAuthUserType["ADMIN"] = "ADMIN";
  WebAuthUserType["SUPPORT"] = "SUPPORT";
  WebAuthUserType["FUNCTION"] = "FUNCTION";
  WebAuthUserType["SERVICE"] = "SERVICE";
  WebAuthUserType["SYSTEM"] = "SYSTEM";
  WebAuthUserType["GMS"] = "GMS";
  WebAuthUserType["VPN"] = "VPN";
  WebAuthUserType["DUMMY"] = "DUMMY";
  return WebAuthUserType;
}(WebAuthUserType || {});
/*
 * Public API Surface of ng-web-auth-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdfsInstance, ClientAuthService, LoginComponent, Organisation, WebAuthModule, WebAuthService, WebAuthUser, WebAuthUserType, isArd };
